import React from 'react';

/**
 * columns: [{ key, label, render?: (row) => node }]
 * Keeping rendering generic here means every module's list page is just a
 * thin config object instead of a hand-rolled <table>.
 */
export default function DataTable({ columns, rows, emptyMessage = 'No records found.', getRowKey }) {
  return (
    <div className="table-wrapper">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={columns.length} className="table-empty">
                {emptyMessage}
              </td>
            </tr>
          )}
          {rows.map((row, idx) => (
            <tr key={getRowKey ? getRowKey(row) : idx}>
              {columns.map((col) => (
                <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
